<script setup lang="ts">
    useModal('invoicing:invoice:updating-condition-alert', async () => {});

    const save = async () => {
        useEvent('invoicing:invoice:updating-condition-alert:close');
    };
</script>

<template>
    <Modal
        ref="modal"
        name="invoicing:invoice:updating-condition-alert"
    >
        <div :class="$theme('modal.title.container')">
            <h2 :class="$theme('modal.title.text', 'px-12')">
                {{ $t('invoicing.invoice_form.updating_conditions_alert.title') }}
            </h2>
        </div>
        <div :class="$theme('modal.padding')">
            <div class="flex justify-center mb-8">
                <div class="max-w-[180px] h-[180px]">
                    <Lottie json="https://shared-assets.trustup.io/lottie/warning.json" />
                </div>
            </div>

            <div :class="$theme('modal.footer.button_container')">
                <LoadingButton
                    :extra-class-name="$theme('modal.footer.button')"
                    :class-name="$theme('button.style.cancel')"
                    prevent-default
                    @clicked="useEvent('invoicing:invoice:updating-condition-alert:close')"
                >
                    {{ $t('actions.cancel') }}
                </LoadingButton>
                <LoadingButton
                    :extra-class-name="$theme('modal.footer.button')"
                    :class-name="$theme('button.style.default')"
                    @clicked="save"
                >
                    {{ $t('actions.understood') }}
                </LoadingButton>
            </div>
        </div>
    </Modal>
</template>
